<!-- Start Navbar Area -->
<div class="navbar-area">
  <div class="navbar-container">
    <nav class="navbar">
      <div class="navbar-brand">
        <a routerLink="/">
          <img src="assets/img/ufp_logo8.png" alt="Union Fire Protection">
        </a>
      </div>

      <div class="navbar-menu">
        <ul class="nav-list">
          <li class="nav-item dropdown">
            <a href="javascript:void(0)" class="nav-link">Home <i class='bx bx-chevron-down'></i></a>
            <ul class="dropdown-menu">
              <li><a routerLink="/" class="dropdown-link">Home Demo - 1</a></li>
              <li><a routerLink="/index-2" class="dropdown-link">Home Demo - 2</a></li>
              <li><a routerLink="/index-3" class="dropdown-link">Home Demo - 3</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a href="javascript:void(0)" class="nav-link">Shop <i class='bx bx-chevron-down'></i></a>
            <ul class="dropdown-menu">
              <li><a routerLink="/shop-full-width-1" class="dropdown-link">Full Width Style 01</a></li>
              <li><a routerLink="/shop-full-width-2" class="dropdown-link">Full Width Style 02</a></li>
              <li><a routerLink="/shop-left-sidebar-1" class="dropdown-link">Left Sidebar Style 01</a></li>
              <li><a routerLink="/shop-left-sidebar-2" class="dropdown-link">Left Sidebar Style 02</a></li>
              <li><a routerLink="/shop-right-sidebar-1" class="dropdown-link">Right Sidebar Style 01</a></li>
              <li><a routerLink="/shop-right-sidebar-2" class="dropdown-link">Right Sidebar Style 02</a></li>
              <li><a routerLink="/cart" class="dropdown-link">Cart</a></li>
              <li><a routerLink="/checkout" class="dropdown-link">Checkout</a></li>
              <li><a routerLink="/wishlist" class="dropdown-link">Wishlist</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a href="javascript:void(0)" class="nav-link">Product <i class='bx bx-chevron-down'></i></a>
            <ul class="dropdown-menu">
              <li><a routerLink="/simple-product" class="dropdown-link">Simple Product</a></li>
              <li><a routerLink="/slider-product" class="dropdown-link">Slider Product</a></li>
              <li><a routerLink="/sticky-product" class="dropdown-link">Sticky Product</a></li>
            </ul>
          </li>
          <li class="nav-item"><a routerLink="/shop-left-sidebar-1" class="nav-link">Accessories</a></li>
          <li class="nav-item dropdown">
            <a href="javascript:void(0)" class="nav-link">Pages <i class='bx bx-chevron-down'></i></a>
            <ul class="dropdown-menu">
              <li><a routerLink="/about" class="dropdown-link">About Us</a></li>
              <li><a routerLink="/gallery" class="dropdown-link">Gallery</a></li>
              <li><a routerLink="/faq" class="dropdown-link">FAQ</a></li>
              <li><a routerLink="/error-404" class="dropdown-link">404 Error Page</a></li>
              <li><a routerLink="/coming-soon" class="dropdown-link">Coming Soon</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a href="javascript:void(0)" class="nav-link">Blog <i class='bx bx-chevron-down'></i></a>
            <ul class="dropdown-menu">
              <li><a routerLink="/blog-grid" class="dropdown-link">Blog Grid</a></li>
              <li><a routerLink="/blog-right-sidebar" class="dropdown-link">Blog Right Sidebar</a></li>
              <li><a routerLink="/blog-details" class="dropdown-link">Blog Details</a></li>
            </ul>
          </li>
          <li class="nav-item"><a routerLink="/contact" class="nav-link">Contact Us</a></li>
        </ul>
      </div>

      <div class="navbar-actions">
        <button class="action-btn search-btn">
          <i class='bx bx-search'></i>
        </button>
        <a routerLink="/cart" class="action-btn cart-btn">
          <i class='bx bx-shopping-bag'></i>
        </a>
        <button class="action-btn menu-btn">
          <i class='bx bx-menu'></i>
        </button>
      </div>
    </nav>
  </div>
</div>
<!-- End Navbar Area -->

<!-- Search Overlay -->
<div class="search-overlay">
  <div class="search-overlay-content">
    <button class="search-close">
      <i class='bx bx-x'></i>
    </button>
    <div class="search-form">
      <input type="text" placeholder="Search here..." class="search-input">
      <button class="search-submit">
        <i class='bx bx-search'></i>
      </button>
    </div>
  </div>
</div>
<!-- End Search Overlay -->